module.exports = __webpack_public_path__ + "520c1d8cd957645591cadaf5123a2a2c.png";